export enum NotificacaoSessionStorage {
    ALERTA_NOTIFICACOES = "alertaNotificacoes",
    NOVAS_NOTIFICACOES = "novasNotificacoes",
}